import React, { useState } from 'react';
import { Alert, AlertTitle } from '@mui/material';

const DatabaseMigrationBanner: React.FC = () => {
  const [isDismissed, setIsDismissed] = useState(
    localStorage.getItem('db_migration_banner_dismissed') === 'true'
  );
  
  if (isDismissed) return null;
  
  return (
    <Alert 
      severity="info" 
      onClose={() => {
        setIsDismissed(true);
        localStorage.setItem('db_migration_banner_dismissed', 'true');
      }}
      sx={{ mb: 2 }}
    >
      <AlertTitle>New: Enhanced Keyword Storage</AlertTitle>
      Keywords are now automatically stored in our database for better organization 
      and future classification capabilities. Your existing workflows continue to work as before.
      <ul style={{ marginTop: 8, paddingLeft: 20 }}>
        <li>Automatic keyword deduplication</li>
        <li>Track classification progress</li>
        <li>Better performance for large datasets</li>
        <li>Prepare for advanced analytics features</li>
      </ul>
    </Alert>
  );
};

export default DatabaseMigrationBanner; 